import Slider from "./components/slider";
import CategorySelect from "./components/categorySelect";
import "./components/swmMovies";



(function () {
    const slider = new Slider(document.getElementById("homeSlider"));

    const resultsContainer = document.getElementById("newsResults");
    const placeholder = document.getElementById("newsPlaceholder");
    const categoriesBar = document.getElementById("newsCategoriesSelectDesktop");
    const categoriesMobileBar = document.getElementById("newsCategoriesSelectMobile");

    if (!resultsContainer) return;

    const requestUrl = resultsContainer.dataset.valueUrl;
    const defaultParam = resultsContainer.dataset.valueParam || "category:aktualnosci";

    const handleCategorySelectFn = async function (categoryName, pageNumber) {
        const taxparam = categoryName || defaultParam;

        const formData = new FormData();
        formData.append("action", "infinite_scrolle");
        formData.append("method", "news_results");
        formData.append("taxparam", taxparam);
        formData.append("paged", pageNumber + 1);

        try {
            const response = await fetch(requestUrl, {
                method: "POST",
                body: formData,
                credentials: "same-origin",
            });

            if (!response.ok) {
                resultsContainer.innerHTML = '<p class="newsResults__empty">Nie udało się wczytać artykułów. Spróbuj ponownie.</p>';
                return false;
            }

            const html = (await response.text()).trim();

            if (!html.length) {
                resultsContainer.innerHTML = '<p class="newsResults__empty">Brak artykułów dla wybranego kraju.</p>';
                return false;
            }

            const resultsFragment = document.createElement("template");
            resultsFragment.innerHTML = html;
            resultsContainer.appendChild(resultsFragment.content);

            return true;
        } catch (error) {
            console.error("News filter request failed", error);
            resultsContainer.innerHTML = '<p class="newsResults__empty">Nie udało się wczytać artykułów. Spróbuj ponownie.</p>';
            return false;
        }
    }

    const newsCategorySelect = new CategorySelect({
        resultsContainer: resultsContainer,
        categoriesBar: categoriesBar,
        categoriesMobileBar: categoriesMobileBar,
        placeholder: placeholder,
        handleCategorySelectFn: handleCategorySelectFn,
        loadMore: false
    });

})()
